<div class="filters_view_bg" [hidden]="!showHideColumnDropdown" (click)="showHideColumnDropdown = false"></div>
<p-table [value]="data" [resizableColumns]="true" columnResizeMode="expand" [responsiveLayout]="'scroll'" [tableStyle]="{ width: '100%' }" [scrollable]="true"
    scrollHeight="400px" [(selection)]="selectedRows">
    <ng-template pTemplate="header">
        <tr *ngIf="tableName == 'Ageing-Report'" class="Ageing-Report">
            <th colspan="2"></th>
            <th>Days</th>
            <th colspan="3">0-2</th>
            <th colspan="3">3-5</th>
            <th colspan="3">6-10</th>
            <th colspan="3">11+</th>
            <th colspan="3">Total</th>
        </tr>
        <tr>
            <th class="position-relative">
                <span (click)="showHideColumnDropdown = !showHideColumnDropdown">
                    <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00073 13.6569 9.00073 12C9.00073 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg> 
                </span>
                <div class="column-dropdown-container" *ngIf="showHideColumnDropdown">
                    <div class="mb-2">
                        <label>
                        <input type="checkbox" class="form-check-input mr-3" [(ngModel)]="selectAll" (change)="toggleAllColumns()"style="cursor: pointer;"
                        >
                        <span>Select All</span>
                    </label>
                   </div>
                    <ul *ngFor="let column of allcolumns; let columnIndex = index" [ngClass]="{'d-none': column.header === 'Redirection'}">
                        <li class="d-flex">
                            <label for="{{column.header}}_{{columnIndex}}">
                                <input type="checkbox" class="form-check-input mr-3" id="{{column.header}}_{{columnIndex}}" [(ngModel)]="column.showColumn" style="cursor: pointer;"
                                (change)="toggleColumnVisibility()">
                                <span>{{column.header}}</span>
                            </label>
                        </li>
                    </ul>
                </div>
            </th>
            <th>
                <p-checkbox [(ngModel)]="isAllSelected" [binary]="true" (onChange)="toggleSelectAll()"></p-checkbox>
            </th>
            <th pResizableColumn *ngFor="let column of columns; let columnIndex = index" [ngClass]="{'d-none': !column.showColumn || column.header === 'Redirection'} "
                (click)="column.sortable ? sortData(columnIndex, column.key) : null" [class.sortable]="column.sortable">
                {{ column.header }}
                <span class="svg-sort" *ngIf="column?.sortable"><svg fill="#000000" width="12px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46 0,194.27 37.087,221.213 "></polygon> <polygon points="404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54 490,295.715 452.913,268.802 "></polygon> </g> </g></svg></span>
                <!-- <span *ngIf="sortedColumnIndex === columnIndex">
                    <i class="pi"
                        [ngClass]="{'pi-sort-amount-up': sortOrder === 'ASC', 'pi-sort-amount-down': sortOrder === 'DESC'}"></i>
                </span> -->
            </th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
        <tr style="cursor: pointer;">
            <td style="width: 40px;">

            </td>
            <td>
                <p-checkbox class="form-check-input" [(ngModel)]="row.selected" (onChange)="onRowSelect(row)"
                    [binary]="true"></p-checkbox>
            </td>
            <td *ngFor="let column of columns; let columnIndex = index" [ngClass]="
            {
            'd-none': !column.showColumn || column.header === 'Redirection',
            'overrun-class': row?.invoiceStatus === 'OVERRUN' && column.key === 'invoiceStatus',
            'within-class': row?.invoiceStatus === 'WITHIN_BUDGET' && column.key === 'invoiceStatus',
            'green-color' : row?.approvalStatus === 'APPROVED' && column.key === 'approvalStatus',
            'yellow-color': ['CREATED', 'PENDING', 'COMMENTED'].includes(row?.approvalStatus) && column.key === 'approvalStatus',
            'red-color': row?.approvalStatus === 'REJECTED' && column.key === 'approvalStatus',
            'pendingBudget': row?.approvalStatus === 'PENDING_BUDGET_UPDATE' && column.key === 'approvalStatus',
            'lightgreen': row?.approvalStatus === 'PARTIALLY_APPROVED' && column.key === 'approvalStatus'
            }"
            [ngStyle]="{'text-align': column.aligntextRight ? 'right' : ''}">
                <ng-container *ngIf="column.type === 'dropdown'">
                    <p-dropdown [options]="dropdownOptions[column.key]" [(ngModel)]="row[column.key]"></p-dropdown>
                </ng-container>

                <ng-container *ngIf="column.type === 'input'">
                    <input pInputText [(ngModel)]="row[column.key]" class="form-control" />
                </ng-container>
                
                <ng-container *ngIf="column.type === 'date'">
                    {{row[column.key] | CustomDatePipe: ''}}
                    <!-- <p-calendar [(ngModel)]="row[column.key]" [showIcon]="true"></p-calendar> -->
                </ng-container>

                <ng-container *ngIf="column.type === 'invoicedate'">
                    {{row[column.key] | CustomDatePipe: 'D-M-YYYY'}}
                    <!-- <p-calendar [(ngModel)]="row[column.key]" [showIcon]="true"></p-calendar> -->
                </ng-container>

                

                <ng-container *ngIf="column.type === 'month'">
                    {{row[column.key] | CustomDatePipe: 'MMMM'}}
                    <!-- <p-calendar [(ngModel)]="row[column.key]" [showIcon]="true"></p-calendar> -->
                </ng-container>
                <ng-container *ngIf="column.type === 'monthYear'">
                    {{row[column.key] | CustomDatePipe: 'MMMM yyyy'}}
                </ng-container>
                

                <ng-container *ngIf="column.type === 'status'">
                    <span >{{ row[column?.key] == 1 ? 'Active':'Inactive' }}</span>
                </ng-container>
                 <ng-container *ngIf="column.type === 'financeStatus'">
                    <span >{{ getStatusText(row[column?.key])}}</span>
                </ng-container>
                
                <ng-container *ngIf="column.type === 'statusBadge'">
                    <span class="successPill" *ngIf="row[column?.key] == 1">Active</span>
                    <span class="errorPill" *ngIf="row[column?.key] == 0">Inactive</span>
                </ng-container>
                
                <ng-container *ngIf="column.type === 'userRole'">
                    <span *ngFor="let wh of row[column.key]; let last = last">{{wh?.roleDescription}}  <span *ngIf="!last">, </span></span>
                </ng-container>

                <ng-container *ngIf="column.type === 'file'">
                    <div style="text-align: center;">
                      <ng-container *ngFor="let url of row[column.key]?.split(',')">
                        <a [href]="url.trim()" class="file" target="_blank">
                          <svg fill="#000000" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" class="icon">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                              <path d="M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"></path>
                            </g>
                          </svg>
                        </a>
                      </ng-container>
                    </div>
                  </ng-container>
                  
                <ng-container *ngIf="column.type === 'location'">
                    <div style="text-align: center;" *ngIf="row[column.key]"> <a href="{{row[column.key]}}" class="file map" target="_blank"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M8.25 9C8.25 6.92893 9.92893 5.25 12 5.25C14.0711 5.25 15.75 6.92893 15.75 9C15.75 11.0711 14.0711 12.75 12 12.75C9.92893 12.75 8.25 11.0711 8.25 9ZM12 6.75C10.7574 6.75 9.75 7.75736 9.75 9C9.75 10.2426 10.7574 11.25 12 11.25C13.2426 11.25 14.25 10.2426 14.25 9C14.25 7.75736 13.2426 6.75 12 6.75Z" ></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M5.45641 8.12724C5.73017 4.80603 8.50555 2.25 11.838 2.25H12.162C15.4945 2.25 18.2698 4.80603 18.5436 8.12724C18.6903 9.90751 18.1404 11.6753 17.0097 13.0581L13.4149 17.4545C12.6836 18.3488 11.3164 18.3488 10.5851 17.4545L6.99032 13.0581C5.85958 11.6752 5.30967 9.90751 5.45641 8.12724ZM11.838 3.75C9.28621 3.75 7.16097 5.70726 6.95134 8.25046C6.83652 9.64343 7.2668 11.0266 8.15154 12.1086L11.7463 16.505C11.8774 16.6653 12.1226 16.6653 12.2537 16.505L15.8485 12.1086C16.7332 11.0266 17.1635 9.64343 17.0487 8.25046C16.839 5.70726 14.7138 3.75 12.162 3.75H11.838Z" ></path> <path d="M7.67082 16.3354C7.85606 15.9649 7.70589 15.5144 7.33541 15.3292C6.96493 15.1439 6.51442 15.2941 6.32918 15.6646L4.32918 19.6646C4.21293 19.8971 4.22536 20.1732 4.36201 20.3943C4.49867 20.6154 4.74007 20.75 5 20.75H19C19.2599 20.75 19.5013 20.6154 19.638 20.3943C19.7746 20.1732 19.7871 19.8971 19.6708 19.6646L17.6708 15.6646C17.4856 15.2941 17.0351 15.1439 16.6646 15.3292C16.2941 15.5144 16.1439 15.9649 16.3292 16.3354L17.7865 19.25H6.21353L7.67082 16.3354Z" ></path> </g></svg></a></div>
                </ng-container>

                <ng-container *ngIf="column.type === 'currentApprover'">
                    <span *ngFor="let wh of row[column.key]; let last = last">
                        <ng-container *ngIf="wh?.approvalStatus == 1 && wh?.viewStatus == 1"><a class="user" (click)="userDetailsClick(wh)">{{wh?.name}}</a></ng-container>
                    </span>
                </ng-container>

                
                <ng-container *ngIf="column.type === 'myinvoice'">
                    <span *ngIf="accessControlService.canWrite('My Invoices')">
                        <ng-container *ngIf="row?.approvalStatus == 'CREATED' || row?.approvalStatus == 'COMMENTED'">
                            <ng-container *ngIf="userDetails?.id == row?.createdBy">
                                <a class="btn btn-primary" (click)="invoiceEditAction(row)">Edit</a>
                            </ng-container>
                        </ng-container>
                    </span>
                </ng-container>        
                <!-- {{row[column.key] | json}} -->
                <ng-container *ngIf="column.type === 'approverPending'">
                    <span *ngFor="let wh of row[column.key]; let last = last">
                        <ng-container *ngIf="wh?.approvalStatus == 1 && wh?.viewStatus == 1 && wh?.isBudgetApprover == 0">
                            <ng-container *ngIf="userDetails?.id == wh?.userId">
                                <a class="btn btn-primary" (click)="invoiceAction(row,wh,'approve')">Approve</a><br/>
                                <a class="btn btn-primary reject" (click)="invoiceAction(row,wh,'reject')">Reject</a> <span *ngIf="userRole !== 'ROLE_FINANCE_CORPORATE'"><br/></span>
                                <a class="btn btn-primary comment" *ngIf="userRole !== 'ROLE_FINANCE_CORPORATE'" (click)="invoiceAction(row,wh,'comment')">Comment</a><br/>
                            </ng-container>
                        </ng-container>
                        
                        <ng-container *ngIf="wh?.approvalStatus == 1 && wh?.viewStatus == 1 && row?.invoiceStatus == 'OVERRUN'">
                            <ng-container *ngIf="wh?.isBudgetApprover == 0">
                                <ng-container *ngIf="userDetails?.id == wh?.userId">
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="wh?.isBudgetApprover == 1 || wh?.isBudgetApprover == 2">
                                <ng-container *ngIf="userDetails?.id == wh?.userId">
                                    <a class="btn btn-primary" (click)="invoiceBudgetAction(row ,wh)">Budget Update</a><br/>
                                    <a class="btn btn-primary comment" (click)="invoiceAction(row,wh,'comment')">Comment</a><br/>
                                </ng-container>
                            </ng-container>
                        </ng-container>  
                    </span>
                </ng-container>
                <ng-container *ngIf="column.type === 'approvedBudget'">
                    <a class="btn btn-primary" (click)="invoiceBudgetAction(row,'approve')">Approve Budget</a><br/>
                    <a class="btn btn-primary reject" (click)="invoiceBudgetAction(row,'reject')">Reject Budget</a><br/>
                </ng-container>
                <ng-container  *ngIf="column.type === 'myinvoice' || column.type === 'approverPending' || column.type === 'approverAction'
                || column.type === 'approverAction'|| column.type === 'approverAction'|| column.type === 'approverAction'">
                    <a class="btn btn-primary viewtrend" (click)="invoiceAction(row,row,'viewtrend')">View Trend</a>
                </ng-container>

                
                <ng-container *ngIf="column.type === 'approverAction'">
                    <ng-container *ngIf="RoleSuperAdmin == 'ROLE_SUPERUSER' && (row?.approvalStatus == 'CREATED' || row?.approvalStatus == 'COMMENTED')">
                        <a class="btn btn-primary" (click)="invoiceEditAction(row)">Edit</a>
                    </ng-container>

                    <span *ngFor="let wh of row[column.key]; let last = last">
                        <ng-container *ngIf="wh?.approvalStatus == 0 && wh?.viewStatus == 0 && row?.invoiceStatus == 'WITHIN_BUDGET'">
                            <ng-container *ngIf="userDetails?.id == wh?.userId">
                                <!-- <a class="btn btn-primary" (click)="invoiceAction(wh)">Action</a> -->
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="wh?.approvalStatus == 0 && wh?.viewStatus == 0 && row?.invoiceStatus == 'OVERRUN'">
                            <ng-container *ngIf="wh?.isBudgetApprover == 0">
                                <ng-container *ngIf="userDetails?.id == wh?.userId">
                                    <!-- <a class="btn btn-primary" (click)="invoiceAction(wh)">Action</a> -->
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="wh?.isBudgetApprover == 1 || wh?.isBudgetApprover == 2">
                                <ng-container *ngIf="userDetails?.id == wh?.userId">
                                    <a class="btn btn-primary" (click)="invoiceBudgetAction(row ,wh)">Budget Action</a>
                                </ng-container>
                            </ng-container>
                        <!-- 
                        </ng-container>
                        <ng-container *ngIf="wh?.approvalStatus == 0 && wh?.viewStatus == 0 && wh?.isBudgetApprover == 2 ">
                            <ng-container *ngIf="userDetails?.id == wh?.userId">
                                <a class="btn btn-primary" (click)="invoiceBudgetAction(row , wh)">Action b</a>
                            </ng-container>
                        </ng-container> -->
                    </ng-container>
                    </span>
                </ng-container>

                <ng-container *ngIf="column.type === 'approvalUser'">
                    <span class="approvalUser" *ngFor="let wh of filteredApprovers(row[column.key],row); let columnIndex = index"
                    [ngClass]="{
                        'beforeApprover': wh?.position === 'before',
                        'currentApprover': wh?.position === 'current',
                        'afterApprover': wh?.position === 'after'
                      }"
                    >
                        <div >{{columnIndex + 1}} - <a class="user" (click)="userDetailsClick(wh)">{{wh?.name}}</a>
                           
                           <span [ngClass]="
                           {
                            'primaryPill': wh?.approvalStatus === 10,
                            'light-green': wh?.approvalStatus === 9,
                            'commentedPill': wh?.approvalStatus === 1 || wh?.approvalStatus === 4 ||  
                                            (row?.approvalStatus === 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1),
                            'budgetreject': wh?.approvalStatus === 5,
                            'successPill': (wh?.approvalStatus === 2 && wh?.isBudgetApprover == 0) || 
                                            (row?.approvalStatus !== 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1),
                            'errorPill': wh?.approvalStatus === 3,
                            
                           }
                           ">
                            {{wh?.approvalStatus === 5 ? 'Budget Skipped' :  
                            wh?.approvalStatus === 1 ? 'Pending' : 
                            wh?.approvalStatus === 8 ? 'Requested For Budget Raise' : 
                            wh?.approvalStatus === 2 && wh?.isBudgetApprover == 0 ? 'Approved' : 
                            wh?.approvalStatus === 9  ? 'Partially Approved' : 
                            row?.approvalStatus != 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1 ? 'Budget Raised' : 
                            row?.approvalStatus == 'PENDING_BUDGET_UPDATE' && wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1 ? 'Requested For Budget Raise' : 
                            wh?.approvalStatus === 3 ? 'Rejected' : 
                            wh?.approvalStatus === 4 ? 'Commented' : '' }} </span>
                             <ng-container *ngIf="
                             wh?.approvalStatus === 5 ? 'Budget Skipped' :  
                            wh?.approvalStatus === 2 && wh?.isBudgetApprover == 0 ? 'Approved' : 
                            wh?.approvalStatus === 2 && wh?.isBudgetApprover == 1 ? 'Budget Raised' : 
                            wh?.approvalStatus === 3 ? 'Rejected' : 
                            wh?.approvalStatus === 4 ? 'Commented' : ''
                              "> - {{wh?.updatedAt | CustomDatePipe: ''}}</ng-container>
                              <ng-container *ngIf="wh?.remarks"> - {{wh?.remarks}}</ng-container>
                            </div>
                    </span>
                </ng-container> 
                <ng-container *ngIf="column.type === 'invoiceLineItems'">
                    <span *ngFor="let exp of row[column.key]; let last = last">{{exp?.expense}} <ng-container *ngIf="exp?.expenseMode">[{{exp?.expenseMode}}]</ng-container> <span *ngIf="!last">, </span></span>
                </ng-container>
                <ng-container *ngIf="column.type === 'invoiceNumber'" class="position-relative">
                    <span *ngFor="let exp of row[column.key]; let last = last">
                        <a class="file" target="_blank"> 
                            <span class="open-popup" [ngClass]="{
                                'approved-class': exp?.lineItemApprovalStatus === 'APPROVED',
                                'rejected-class': exp?.lineItemApprovalStatus === 'REJECTED' || row.approvalStatus === 'REJECTED'
                            }">
                            
                                <ng-container *ngIf="exp?.invoiceUrl && !exp?.supportDocUrl">
                                    <a *ngIf="exp?.invoiceUrl" [href]="getEncodedInvoiceUrl(exp?.invoiceUrl)" target="_blank" class="url-chip">{{exp?.invoiceNumber}}</a>
                                </ng-container>
                                <ng-container *ngIf="exp?.invoiceUrl && exp?.supportDocUrl">
                                {{exp?.invoiceNumber}}              
                                <span class="doc-popup">
                                    <!-- {{getExtType(exp?.invoiceUrl)}} -->
                                    <a *ngIf="exp?.invoiceUrl" [href]="getEncodedInvoiceUrl(exp?.invoiceUrl)" target="_blank" class="url-chip">Invoice Doc</a>
                                    <a *ngIf="exp?.supportDocUrl" [href]="getEncodedInvoiceUrl(exp?.supportDocUrl)" target="_blank" class="url-chip">Support Doc</a>
                                </span>
                                </ng-container>
                            </span>
                        </a>
                        <span *ngIf="!last">, </span>
                    </span>
                </ng-container>

               
            
                <ng-container *ngIf="column.type === 'expenseModeMapping'">
                    <span *ngFor="let exp of row[column.key]; let last = last">{{ getStatusText(exp?.expenseMode) }}<span *ngIf="!last">, </span></span>
                </ng-container>

                <ng-container *ngIf="column.type === 'warehouse'">
                    <span *ngFor="let wh of row[column.key]; let last = last">{{wh?.warehouseId}} <span *ngIf="!last">, </span></span>
                </ng-container>

                <ng-container *ngIf="column.type === 'customerwarehouse'">
                    <span *ngFor="let wh of row[column.key]; let last = last">{{wh?.clientName}}-{{wh?.warehouseName}}  <span *ngIf="!last">, </span></span>
                </ng-container>

                <ng-container *ngIf="column.type === 'expense'">                            
                            <span *ngFor="let wh of row[column.key] ; let last = last">{{wh?.expense}}  <span *ngIf="!last">, </span></span>
                </ng-container>

                <ng-container *ngIf="column.type === 'revenueAttribute'">
                    <span *ngFor="let wh of row[column.key] ; let last = last">{{wh?.quickCodeName}}  <span *ngIf="!last">, </span></span>
                </ng-container>
                
                <ng-container *ngIf="column.type === 'document'">
                    <div class="mb-2" *ngFor="let item of row[column.key]">
                        <a [href]="item" target="_blank">{{item}}</a>
                    </div>
                    <!-- <input pInputText [(ngModel)]="row[column.key]" class="form-control" /> -->
                </ng-container>

                <ng-container *ngIf="column.type === 'text'">
                    <ng-container *ngIf="column?.key == 'approvalHierarchy'">
                        <div class="mb-2" *ngFor="let name of sortApproval(row[column.key])">{{name?.sequence}} {{name?.designation}} <span class="{{name?.condition}}">{{name?.condition}}</span></div>
                    </ng-container>
                    <ng-container *ngIf="column?.key != 'approvalHierarchy'">
                    

                    <span *ngIf="column.viewDialog" (click)="openRowDetailsDialog(column, row)">
                      <a href="javascript:void(0)">{{ row[column.key] }}</a>
                    </span>
                    <span *ngIf="column.isRedirect" (click)="redirection(column, row,column.key,row[column.key])">
                        <a href="javascript:void(0)" style="text-decoration: underline;font-weight: 600;">{{ row[column.key] > 0 ? row[column.key] : ''  }}</a>
                      </span>
                    <ng-container *ngIf="!column.viewDialog && !column.isRedirect">
                        <span *ngIf="column.tooltip && row[column.key]?.split(',').length > 2"
                            pTooltip="{{ row[column.key] }}" tooltipPosition="top" [tooltipDisabled]="false"
                            [tooltipStyleClass]="'custom-tooltip'"
                            [tooltipOptions]="tooltipOptions">
                            {{ row[column.key] | slice:0:20 }}...
                        </span>
                        <span *ngIf="column.tooltip && (row[column.key]?.split(',').length <= 2)">
                            {{ row[column.key] }}
                        </span>
                        <span *ngIf="!column.tooltip">
                            <!-- {{ row | json }} -->
                            <!-- {{ getStatusText(row[column.key]) }} -->
                            {{ getDisplayValue(row[column.key]) }}
                        </span>
                    </ng-container>
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="footer" let-column *ngIf="tableName === 'Ageing-Report'">
        <tr class="total-row" *ngIf="showFooterTotalRow">
            <td></td>
            <td></td>
            <td *ngFor="let col of columns" [ngClass]="{'text-end': col.aligntextRight, 'text-start': !col.aligntextRight, 'd-none': col.key === 'invoiceId02' || col.key === 'invoiceId35' || col.key === 'invoiceId610' || col.key === 'invoiceId11Plus'}">
              <ng-container *ngIf="col.key === 'userName'">Total</ng-container>
              <ng-container *ngIf="col.key !== 'userName' && col.key !== 'invoiceId02' && col.key !== 'invoiceId35' && col.key !== 'invoiceId610' && col.key !== 'invoiceId11Plus'">
                <span>
                    <!-- {{col.key}} -->
                    {{ footerTotalData[col.key] || '' }}
                </span>
              </ng-container>
            </td>
          </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="23" rowspan="5" style="color: red;padding: 30px;">Not found.</td>
        </tr>
      </ng-template>
</p-table>